import React from 'react';
import { Panel, PanelPresets, UserPermissionsIds } from 'utility/enumerations';
import { ViewMounter } from 'components/view_mounter';
import { SecureRoute } from 'components/shared/secure_route';

function QualifyingDocContainerScreen() {
  return (
    <div>
      {/* *** Link to Admin Dashboard for All Qualifying Docs (Link from Main Menu -> Manage Patients -> Qualifying Documentation) *** */}
      <SecureRoute
        path="/qualifying-documentation"
        pathPermissionId={UserPermissionsIds.AccessQualifyingDocAll}
        render={(props) => ViewMounter(props, {
          viewPath: 'caregiver/qualifying_doc/qualifying_doc_screen_admin',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          viewProps: undefined,
          focusView: false,
          clear: false,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      {/* *** Link to Admin Dashboard for a Caregiver (Link from Caregiver Profile) *** */}
      <SecureRoute
        path="/qualifying-documentation/caregiver/:caregiverEncryptedId"
        pathPermissionId={UserPermissionsIds.AccessQualifyingDocAll}
        render={(props) => ViewMounter(props, {
          viewPath: 'caregiver/qualifying_doc/qualifying_doc_screen_admin',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          viewProps: undefined,
          focusView: false,
          clear: false,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      {/* *** Link to Admin Dashboard for a Patient (Link from Patient Profile) *** */}
      <SecureRoute
        path="/qualifying-documentation/patient/:patientEncryptedId"
        pathPermissionId={UserPermissionsIds.AccessQualifyingDocAll}
        render={(props) => ViewMounter(props, {
          viewPath: 'caregiver/qualifying_doc/qualifying_doc_screen_admin',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          viewProps: undefined,
          focusView: false,
          clear: false,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      {/* *** Admin Dashboard View Button Link to CRCE *** */}
      <SecureRoute
        path="/qualifying-documentation/crce/:encryptedId"
        pathPermissionId={UserPermissionsIds.ReadQualifyingDoc}
        render={(props) => ViewMounter(props, {
          viewPath: 'caregiver/qualifying_doc/close_relative/close_relative_caregiver_exception',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          viewProps: { isAdmin: true },
          focusView: false,
          clear: false,
          overrideLocation: '',
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
    </div>
  );
}

export default QualifyingDocContainerScreen;
